import { useStaticQuery, graphql } from 'gatsby'

export default () =>
  useStaticQuery(
    graphql`
      query {
        staticData {
          kbbHeaderFooterData {
            footerLinks {
              id
              name
              omnitureTag
              omnitureTagSuffix
              partnerLink
              target
              url
            }
            headerLinks {
              id
              name
              omnitureTag
              omnitureTagSuffix
              partnerLink
              target
              url
              dropdownItems {
                name
                url
              }
            }
          }
        }
      }
    `
  ).staticData
